import { render, staticRenderFns } from "./soundLib.vue?vue&type=template&id=457d5fe6&scoped=true&"
import script from "./soundLib.vue?vue&type=script&lang=js&"
export * from "./soundLib.vue?vue&type=script&lang=js&"
import style0 from "./soundLib.vue?vue&type=style&index=0&id=457d5fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457d5fe6",
  null
  
)

export default component.exports